import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"

import Button from "legacy/components/shared/Button"
import { Element } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import HeaderLogo from "./HeaderLogo"
import Navigation from "./Navigation"
import { useTheme } from "src/legacy/utils"

const Header: React.FC = (): React.ReactElement => {
  const navData = useStaticQuery(graphql`
    query Navigation($language: String! = "en") {
      locales: allLocale(
        filter: { ns: { in: ["shared"] }, language: { eq: $language } }
      ) {
        edges {
          node {
            ns
            data
            language
          }
        }
      }
      allPrismicNavigation {
        edges {
          node {
            data {
              body {
                ... on PrismicNavigationDataBodyTopLevelItem {
                  id
                  items {
                    link_text
                    link_url {
                      document {
                        ... on PrismicBlogPost {
                          id
                          uid
                          url
                        }
                        ... on PrismicLegalPage {
                          id
                          uid
                          url
                        }
                        ... on PrismicHomepage {
                          id
                          url
                        }
                        ... on PrismicOurMissionPage {
                          id
                          uid
                          url
                        }
                        ... on PrismicPage {
                          id
                          uid
                          url
                        }
                      }
                      id
                      link_type
                      type
                      uid
                      url
                    }
                  }
                  primary {
                    menu_name
                  }
                }
              }
              logo {
                alt
                url
              }
            }
          }
        }
      }
    }
  `)

  const addAnalytics = (): void => {
    analytics.track("Download Button Clicked")
  }

  const { t } = useTranslation("shared", {
    keyPrefix: "navigation",
  })

  const { logo, body } = navData.allPrismicNavigation.edges[0].node.data
  const { sizes } = useTheme()

  return (
    <Element as="header" bg="white" position="fixed" width="100%" zIndex={3}>
      <Grid
        alignItems="center"
        gridTemplateColumns={[
          "1fr auto auto",
          "1fr auto auto",
          "1fr auto auto",
          "150px 1fr",
        ]}
        justifyContent="flex-end"
        margin="0 auto"
        maxWidth={sizes.maxWidth}
        padding={["12px 30px", "12px 30px", "12px 30px", "23px 50px"]}
      >
        <HeaderLogo logo={logo} />
        <Element
          as="a"
          display={["inline-block", "inline-block", "inline-block", "none"]}
          href="/app/"
        >
          <Button
            fontSize="13"
            fontWeight="regular"
            onClick={addAnalytics}
            px="12px"
            py="8px"
          >
            {t("book_now")}
          </Button>
        </Element>
        <Navigation navItems={body} />
      </Grid>
    </Element>
  )
}

export default Header
